import PageContainer from '@/common/components/PageContainer'

const AdminDashboardPage = () => {
	return (
		<PageContainer>
			<div>AdminDashboardPage</div>
		</PageContainer>
	)
}

export default AdminDashboardPage
